import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import * as Util from '../../../common/utilities';
import ErrorImg from '../../../static/img/error-something-went-wrong.svg';

import { AssetEditFields } from '../';

import { Spinner, Tooltip } from '@salesforce/design-system-react';

import './AssetTagFields.scss';

class AssetTagFields extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: undefined
    };
  }
  componentDidMount() {
    const { asset, tags } = this.props;
    if (!asset.ect_tags && !tags?.data?.tags?.length) {
      const url = this.imageUrl(asset);
      this.props.actions.createTags(url);
    }
  }

  imageUrl(asset) {
    if (asset.image_url?.length) {
      return asset.image_url;
    } else {
      return asset.image_link;
    }
  }

  componentDidUpdate(prevProps) {
    if (Util.propChanged(prevProps, this.props, 'tags.data.tags')) {
      if (!this.props.asset.ect_tags) {
        const tags = this.props.tags.data.tags.map(tag => ({
          ...tag,
          selected: true
        }));
        this.props.onFieldChange(undefined, tags);
      }
    }

    if (Util.propChanged(prevProps, this.props, 'tags.error')) {
      this.setState({ error: this.props.tags.error });
    }
  }

  renderSpinner() {
    return (
      <div className="tag-spinner">
        <Spinner variant="brand" />
      </div>
    );
  }

  renderError() {
    const { formatMessage } = this.props.intl;

    const error = formatMessage({
      id: 'components.ecs.assetWizard.tags.error'
    });

    return (
      <div className="tag-fields-root">
        <div className="tag-error-container">
          <div className="tag-error-image">
            <img src={ErrorImg} alt="Data Unavailable: Something went wrong." />
          </div>
          {error}
        </div>
      </div>
    );
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { asset, modals, mode, tags } = this.props;

    if (this.state.error) {
      return this.renderError();
    }
    if (!asset.ect_tags && !tags.data?.tags?.length && !tags.error) {
      return this.renderSpinner();
    }

    const header = formatMessage({
      id: 'components.ecs.assetWizard.tags.header'
    });

    const description = formatMessage({
      id: 'components.ecs.assetWizard.tags.description'
    });

    const imageLabel = formatMessage({
      id: 'components.ecs.assetWizard.tags.imageLabel'
    });

    const tooltipContent = formatMessage({
      id: 'components.ecs.assetWizard.tags.tooltip'
    });

    const tooltip = (
      <Tooltip align="right" content={tooltipContent} variant="learnMore" />
    );

    return (
      <div className="tag-fields-root">
        <h1>{header}</h1>
        <span className="tag-fields-desc">
          {description}
          {tooltip}
        </span>
        <div className="tag-field-container">
          <div className="tag-image-preview">
            <p>{imageLabel}</p>
            <img src={this.imageUrl(asset)} alt="Tagged preview" />
          </div>
          <AssetEditFields
            modals={modals}
            mode={mode}
            asset={asset}
            type="tags"
            onFieldChange={this.props.onFieldChange}
          />
        </div>
      </div>
    );
  }
}

AssetTagFields.propTypes = {
  actions: PropTypes.object,
  asset: PropTypes.object,
  errors: PropTypes.object,
  tags: PropTypes.object,
  mode: PropTypes.oneOf(['edit', 'create']),
  modals: PropTypes.object,
  onFieldChange: PropTypes.func.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(AssetTagFields);
